import { z } from "zod";

export const NewHireSchema = z.object({
  full_name: z.string().min(1, "Full name is required"),
  email: z.string().email("Invalid email address"),
  address: z.string().min(1, "Address is required"),
  contact_number: z.string().min(1, "Contact number is required"),
  position: z.string().min(1, "Position is required"),
  employment_type: z.string().min(1, "Employeement Type is Required"),
  letter_type: z.string().min(1, "Letter Type is Required"),
});

export type NewHireFormValues = z.infer<typeof NewHireSchema>;
